import axios, { AxiosRequestConfig } from "axios";
import { convertObjectToUrlParams } from "../helpers/convertObjToUrlParams";
import { getFormattedDateMMDDYYYY } from "../helpers/getFormattedDateMMDDYYYY";

const config: AxiosRequestConfig = {
  responseType: "blob",
  headers: {
    Accept: "text/csv",
  },
};

export const getAgencyDataCSVDownload = async (params: any) => {
  try {
    const response = await axios.get(
      `${
        process.env.REACT_APP_API
      }/Export/AgencyData-Latest-CSV-Download${convertObjectToUrlParams(
        params
      )}`,
      config
    );

    let fileName;

    if (params.beginDate && params.endDate) {
      fileName = `Catch Reports Export ${getFormattedDateMMDDYYYY(
        params.beginDate
      )} - ${getFormattedDateMMDDYYYY(params.endDate)}`;
    } else {
      fileName = "Catch Reports Export";
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.style.display = "none";
    link.setAttribute("download", `${fileName}.csv`);

    document.body.appendChild(link);
    link.click();

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
